import {Component, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from "@angular/forms";
import { Observable, throwError } from 'rxjs';
import {Register} from "./Register";
import {LogService} from "../Abstract/log.service";
import {ConfigService} from "../../Core/Abstract/config.service";
import { VisualsService } from '../Abstract/visuals.service';
import {EventsEmitterService} from "../../Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "../Login/passwordValidator.component";
import {matchOtherValidator} from "../Login//matchOtherValidator.component";
import {RegisterService} from "./register.service";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'register',
    templateUrl: 'register.component.html',
    providers: [RegisterService]
})

export class RegisterComponent implements OnInit {


    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    @ViewChild('otpModal',{static: false}) public otpModal: ModalDirective;

    
    /*
     *  Modal handling
     */

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    public showOptModal(): void {
        this.otpModal.show();
    }

    public hideOptModal(): void {
        this.otpModal.hide();
    }
    currentLang =  this.configService.getCurrentLocaleStr();
    langs = this.configService.getLangs();

    public emailPattern =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    protected redirectTitle = "";
    protected redirectMsg = "";
    private token: String;
    private loading: boolean = false;
    private manualTokenInput: boolean = false;
    private pwdmodel:Register;   
    private otpModel:any;     
    private regexList:Array<PasswordValidatorOptions> = [];
    private rulesArray:Array<Object> = [];
    private validateTokenHasError:boolean = false;
    submitting: boolean = false;
    countryList = [];
    countryCodesList = [];
    selectedVal: boolean = false;
    selected:any;
    private pwdForm: UntypedFormGroup;
    otpForm: UntypedFormGroup;
    private validationMessages= {};
    private formErrors = {
        'email': 'This is not valid email',
        'firstname': '',
        'lastname': '',
        'mobile': '',
        'mobileCode': '',
        'country': '',
        // 'username': '',
        'password': '',
        'passwordConf': '',
        'captcha': ''
    };

    pwderror = false;
    pwdmsg = "";
    public barLabel: string = "";

    constructor(private registerService: RegisterService, private logger: LogService, private fb: UntypedFormBuilder, public translate:TranslateService,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService, protected route: ActivatedRoute,
                protected visualsService: VisualsService) {

        this.pwdmodel = new Register("", "", "", "", "", null, null, "", "","","","");  
        this.getRules();
        localStorage.setItem('langId', this.configService.getLangDefault() ? this.configService.getLangDefault().toString() : '2' );
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(
            params => {
                this.pwdmodel.email = params.email;
                this.pwdmodel.token = params.token;
                if(params.token){
                    this.manualTokenInput=false;
                    this.validateToken();
                }
                else {
                    this.validateTokenHasError=true;
                    this.manualTokenInput=true;
                }
                if(params.lang){
                    this.changeLang(params.lang);
                }
            },
            error => {
               return throwError(error);
            }
        );
        this.buildForm();
        this.getCountryList(localStorage.getItem('langId'));
        this.getCountryCodesList(localStorage.getItem('langId'));
    }

    openOtpModal(){
        this.otpForm.reset();
        this.showOptModal();
    }
    getCountryList(langId){
        this.registerService.getCountryList(langId)
        .subscribe(
          data => {
              this.countryList = data;
              this.loading = false;
          },
          error => {
            this.logger.info(error);
            this.loading = false;
          }
        );
    }

    getCountryCodesList(langId){
        this.registerService.getCountryCodesList(langId)
        .subscribe(
          data => {
              this.countryCodesList = data;
              this.loading = false;
          },
          error => {
            this.logger.info(error);
            this.loading = false;
          }
        );
    }

    dropdown(){
        console.log("n")
        this.selectedVal = false
    }

    resolved(captchaResponse: string) {
        this.pwdmodel.captcha = captchaResponse;
        console.log(`Resolved captcha with response ${captchaResponse}:`);
    }

    protected getRules(): void {
        this.registerService.getRules().subscribe(
            data => {
                this.logger.log(data);
                this.rulesArray = data;
                this.rulesArray.forEach(rule => {
                    //this.logger.log(rule);
                    if(rule['regex'] != null && rule['regex'] != ''){
                        this.regexList.push(new PasswordValidatorOptions(new RegExp(rule['regex']), rule['name']));
                    }
                });
                
            },
            error => {
                this.logger.log("Could not get pass rules!");
                this.registerService.goToLogin();
            }
        );
    }

    validateToken(){
        this.loading = true;
        this.registerService.validateToken(this.pwdmodel.token).subscribe(
            data => {
                this.loading = false;
                if(data == 'valid'){
                    this.validateTokenHasError = false;
                    this.manualTokenInput=false;
                }
                else if(data == 'expired'){
                    this.validateTokenHasError = true
                    this.redirectTitle = 'Your token has expired';
                    this.redirectMsg = 'Resend Verification Mail!'
                    this.showChildModal();
                }
               else if(data == 'invalidToken'){ 
                this.validateTokenHasError = true
                this.redirectTitle = 'Your token is invalid';
                this.redirectMsg = 'Your token is invalid'
                this.showChildModal();
               }
               this.hideOptModal();
            },
            error => {
                this.validateTokenHasError = true;
                this.redirectTitle = 'Something went wrong.';
                this.redirectMsg = ''
                this.loading = false;
                this.logger.log("Could not get pass rules!");
            }
        );
    }

    private buildForm() {
        this.otpForm = new UntypedFormGroup({
            'otp': new UntypedFormControl(null, [Validators.required])
        });
        this.pwdForm = new UntypedFormGroup({
            'email': new UntypedFormControl(this.pwdmodel.email, [Validators.required, Validators.pattern(this.emailPattern)]),
            'firstName': new UntypedFormControl(this.pwdmodel.firstName, [Validators.required]),
            'lastName': new UntypedFormControl(this.pwdmodel.lastName, [Validators.required]),
            'mobileNumber': new UntypedFormControl(this.pwdmodel.mobileNumber, [Validators.required]),
            'mobileCode' : new UntypedFormControl(this.pwdmodel.mobileCode, [Validators.required]),
            'country': new UntypedFormControl(this.pwdmodel.country, [Validators.required]),
            'password': new UntypedFormControl(this.pwdmodel.password, [Validators.required, passwordValidator(this.regexList)]),
            'passwordConf': new UntypedFormControl(this.pwdmodel.passwordConf, [Validators.required, matchOtherValidator('password')]),
            'captcha': new UntypedFormControl(null, Validators.required)
        });

        this.validationMessages = {
            'email': {
                'required': 'Required field',
                'pattern': 'Please provide a valid email.'
            },
            'country': {
                'required': 'Required field'
            },
            'firstname': {
                'required': 'Required field'
            },
            'lastname': {
                'required': 'Required field'
            },
            'mobileNumber': {
                'required': 'Required field'
            },
            'mobileCode' : {
                'required': 'Required field'
            },
            // 'username': {
            //     'required': 'Required field'
            // },
            'password': {
               
            },
            'passwordConf': {
                'required': 'Required field',
                'matchOther': 'Passwords do not match'
            },
            'captcha': {
            }
        };

        this.pwdForm.valueChanges.subscribe(data => this.onValueChanged(data));

        this.onValueChanged();
    }

    /*
     *  Different impl with formErrors as Array<string>
     */
    onValueChanged(data?: any) {
        if (!this.pwdForm) { return; }
        
        console.log(this.pwdForm);

        //set custom regex visuals here
        //cannot move this in build form, messages are empty 
        this.rulesArray.forEach(rule => {
            if(rule['regex'] != null && rule['regex'] != ''){
                this.validationMessages['password'][rule['name']] = rule['message'] || 'Password not matching criteria';
            }
        });

        const form = this.pwdForm;
        //this.logger.log(this.pwdForm);
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = [];
            const control = form.get(field);

            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                //this.logger.log(control.errors)
                for (const key in control.errors) {
                    this.formErrors[field].push(messages[key]);
                }
            }
        }
        
        // this.logger.log("formerrors: " + JSON.stringify(this.formErrors));
    }

    public returnToLogin(){
        this.registerService.goToLogin();
    }

    public doRegister(pwdmodel: Register){
        this.submitting = true
        if(!this.pwdForm.valid){
            return
        }
        this.loading = true;
        this.pwderror = false;
      //  this.pwdmodel.mobile = this.pwdmodel.mobileCode + this.pwdmodel.mobile;

        this.pwdmodel.mobile =  this.pwdmodel.mobileNumber;
        this.registerService.registerRequest(pwdmodel).subscribe(
            data => {
                this.logger.log(data);
                this.loading = false;
                this.validateTokenHasError = false;
                this.redirectTitle = 'Registered Successfully';
                this.redirectMsg = 'A verification email has been sent. Please verify your account to enable login.';
                this.showChildModal();
            },
            error => {
                this.loading = false;
                this.pwdmodel.mobile = '';
                //reset for every request
                this.pwdmodel.captcha = '';
                this.pwdForm.controls['captcha'].setValue('');
                this.pwderror = true;
                this.pwdmsg = error;

                this.logger.error(error);
                return throwError(error);
            }
            
        );
        
    }
 
 
  selectEvent(item) {
    this.pwdForm.controls['mobileCode'].setValue(item.val);
      this.selected = item.val
  }
 
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
    // do something when input is focused
  }
  submitOtp(){
    this.pwdmodel.token = this.otpForm.value.otp;
    this.validateToken();
  }
  public changeLang(langId) {
    localStorage.setItem('langId', langId);
    this.eventsEmitterService.languageChange.emit(langId);
    this.translate.use(langId);
    this.getCountryList(langId);
    this.getCountryCodesList(langId);
  }
}